export class EntraRestoreReportSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requested",
            "baseName": "requested",
            "type": "number",
            "format": ""
        },
        {
            "name": "restored",
            "baseName": "restored",
            "type": "number",
            "format": ""
        },
        {
            "name": "skippedAlreadyExists",
            "baseName": "skippedAlreadyExists",
            "type": "number",
            "format": ""
        },
        {
            "name": "failed",
            "baseName": "failed",
            "type": "number",
            "format": ""
        },
        {
            "name": "byType",
            "baseName": "byType",
            "type": "{ [key: string]: EntraRestoreReportSummaryByTypeValue; }",
            "format": ""
        },
        {
            "name": "byMethod",
            "baseName": "byMethod",
            "type": "EntraRestoreReportSummaryByMethod",
            "format": ""
        },
        {
            "name": "requiredActionCounts",
            "baseName": "requiredActionCounts",
            "type": "{ [key: string]: number; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportSummary.attributeTypeMap;
    }
    constructor() {
    }
}
